/**
 * State interface for Data Export feature
 */
export interface DataExportState {
    status: DataExportStatus;
    loading: boolean;
    error: string | null;
}

/**
 * Status enum for tracking export lifecycle
 */
export enum DataExportStatus {
    Idle = 'Idle',
    Exporting = 'Exporting',
    ExportSuccess = 'ExportSuccess',
    ExportError = 'ExportError'
}
